import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MatPageable, PageableResponse } from '@core/table/mat-table';
import { buildQueryString } from '@shared/util/util';
import { HttpParams } from '@angular/common/http';
import { DomainCacheService } from './domain-cache.service';

export interface Parametrizacao {
  id?: number;
  nome: string;
  descricao?: string;
}

const baseRef = 'parametrizacao';
const route = {
  buscar: (id: number) => `${baseRef}/${id}`,
  salvarOuAtualizar: `${baseRef}`,
  listar: `${baseRef}/listar`,
  validarLimiteDatas: `${baseRef}/validar-datas`
};

@Injectable({
  providedIn: 'root'
})
export class ParametrizacaoService {

  constructor(
    private apiService: ApiService,
    private domainCache: DomainCacheService
  ) {}

  buscarPorId(id: number): Observable<Parametrizacao> {
    return this.apiService.get<Parametrizacao>(route.buscar(id));
  }

  listar(filtro: any, page?: MatPageable) {
    const query = page?.query ?? '?page=0&size=10';
    return this.apiService.post<PageableResponse<any>>(
      `${route.listar}${query}`,
      this.apiService.removeNullPropertys(filtro)
    );
  }

  listarSort(filtro: any, page: MatPageable, params: any) {
    const queryString = buildQueryString({ ...params });
    const fullUrl = `${route.listar}${page.query}${queryString}`;
    return this.apiService.post<PageableResponse<any>>(
      fullUrl,
      this.apiService.removeNullPropertys(filtro)
    );
  }

  salvarOuAtualizar(param: Parametrizacao): Observable<Parametrizacao> {
    const request$ = param.id
      ? this.apiService.put<Parametrizacao>(`${route.salvarOuAtualizar}/${param.id}`, param)
      : this.apiService.post<Parametrizacao>(route.salvarOuAtualizar, param);
    return request$.pipe(
      tap(() => this.domainCache.invalidateByPrefix('parametrizacao/'))
    );
  }

  validarLimiteDatas(dataInicio: string, dataFim: string): Observable<boolean> {
    const key = `parametrizacao/validar-datas/${dataInicio}|${dataFim}`;
    return this.domainCache.getOrLoad(key, () => {
      const params = new HttpParams()
        .set('dataInicio', dataInicio)
        .set('dataFim', dataFim);
      return this.apiService.get<boolean>(route.validarLimiteDatas, params, undefined, true);
    });
  }
}
